// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customerGrid{margin-left:0 !important;margin-right:0 !important;padding-right:9px;padding-left:9px;padding-top:10px;display:flex;align-items:center}.customerGrid .input-field{height:21px}.customerGrid .input-field input{margin-bottom:0}.customerGrid .react-select__control{background-color:transparent !important}.customerGrid .pagination{margin-top:0}.bg-white{background-color:#ffffff}\n", ""]);
// Exports
module.exports = exports;
